var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 68,
    viewBox: "0 0 102 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 68,
    rx: 7.55556,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 100,
    height: 66,
    rx: 6.55556,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Visa Logo",
    d: "M63.0062 20.7247C57.3732 20.7247 52.3393 23.6444 52.3393 29.0387C52.3393 35.225 61.2671 35.6523 61.2671 38.7601C61.2671 40.0687 59.7675 41.24 57.2062 41.24C53.5713 41.24 50.8545 39.6033 50.8545 39.6033L49.692 45.0468C49.692 45.0468 52.8217 46.4293 56.9768 46.4293C63.1355 46.4293 67.9816 43.3663 67.9816 37.8797C67.9816 31.3428 59.0166 30.9282 59.0166 28.0437C59.0166 27.0186 60.2476 25.8954 62.8016 25.8954C65.6832 25.8954 68.0343 27.0858 68.0343 27.0858L69.1719 21.8283C69.1719 21.8283 66.6138 20.7247 63.0062 20.7247ZM11.4699 21.1215L11.3335 21.9151C11.3335 21.9151 13.7033 22.3488 15.8377 23.214C18.5859 24.2061 18.7817 24.7836 19.2445 26.5774L24.2881 46.0201H31.049L41.4648 21.1215H34.7193L28.0266 38.0502L25.2956 23.7007C25.0451 22.0584 23.7764 21.1215 22.2235 21.1215H11.4699ZM44.1772 21.1215L38.8856 46.0201H45.318L50.591 21.1215H44.1772ZM80.0527 21.1215C78.5016 21.1215 77.6798 21.9519 77.0768 23.4031L67.653 46.0201H74.3984L75.7035 42.2506H83.9214L84.715 46.0201H90.6668L85.4744 21.1215H80.0527ZM80.93 27.8484L82.9294 37.1915H77.5727L80.93 27.8484Z",
    fill: "#C8283B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.397c19c9a45ce572ba21d17c62c19143.svg";
export { ForwardRef as ReactComponent };